import requests from 'app/requests/Order/OrderComments.requests'
import useRequestTable from 'app/hooks/useRequestTable'

import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    CommentType,
} from 'app/shared-components/CommentsLog/CommentsLog.types'

const useGetOrderComments = (orderNumber) => {
    const {
        onParamsChange,
        isDataReady,
        refetch,
        data,
        loadData,
    } = useRequestTable<CommentType>({
        key: RequestKeys.getOrderComments,
        params: {
            orderNumber,
        },
        config: requests.filterRequestAll,
        keepPreviousData: true,
    })

    return {
        onParamsChange,
        isDataReady,
        refetch,
        data,
        loadData,
    }
}

export default useGetOrderComments
